import React from "react";
import "../../styles/Homecantainer.css";

import WebIcon from "../../assets/clients/f1.webp";
import DesignIcon from "../../assets/clients/f2.webp";
import SEOIcon from "../../assets/clients/f3.webp";
import DigitalIcon from "../../assets/clients/f4.webp";
import brandingIcon from "../../assets/clients/f1.webp";
import contentIcon from "../../assets/clients/f2.webp";

const Services = () => {
  const servicesData = [
    {
      icon: WebIcon,
      title: "Web Development",
      desc: "Build fast, secure and scalable websites with custom web development solutions from a trusted web development company in Noida, including dynamic features, integrations and performance optimization, ensuring smooth functionality, better user experience and higher conversions for your business.",
      features: [
        "Static Website Development",
        "Dynamic Website Development",
        "Custom Website Development",
        "E-Commerce Website Development",
        "WordPress Development",
        "API Integration",
        "Website Speed Optimization",
      ],
      link: "/web-development-company-in-noida",
    },
    {
      icon: DesignIcon,
      title: "Web Design ",
      desc: "Create modern, responsive and visually engaging website designs focused on user experience, clear navigation and brand identity, helping visitors stay longer, build trust and convert into potential customers.",
      features: [
        "UI/UX Design",
        "Website Layout Design",
        "Responsive Website Design",
        "Landing Page Design",
        "E-Commerce Store Design",
        "Dashboard / Admin Panel Design",
        "Logo & Branding Design",
        "Banner & Graphics Design",
      ],
      link: "/ui-ux-design-services",
    },
    {
      icon: SEOIcon,
      title: " SEO Services",
      desc: "Improve search rankings and drive organic traffic with professional SEO services including keyword research, on-page optimization, technical fixes, and link building strategies designed to boost visibility, leads, and consistent growth.",
      features: [
        "Website SEO Audit",
        "Keyword Research & Planning",
        "On-Page SEO Optimization",
        "Content Optimization",
        "Image & Speed Optimization",
        "Schema Markup Implementation",
        "Landing Page SEO",
        "Indexing Issues Fixing",
      ],
      link: "/seo-agency-noida",
    },
    {
      icon: DigitalIcon,
      title: "Social Media Marketing",
      desc: "Grow your brand presence, increase engagement, and generate quality leads with result-driven social media marketing strategies. We create impactful content, manage your accounts, and run targeted campaigns to help your business reach the right audience and achieve consistent growth. ",

      features: [
        "Social Media Strategy ",
        "Content Creation",
        "Social Media Management",
        "Growth Strategy",
        "Analytics & Reporting",
      ],
      link: "/social-media-marketing-services",
    },
    {
      icon: brandingIcon,
      title: "Content Marketing",
      desc: "Build authority and attract customers with strategic content marketing including blogs, website copy, social media posts, and conversion-focused content designed to improve engagement, search rankings, and generate consistent leads.",
      features: [
        "Website Content Writing",
        "SEO Blog Writing",
        "Landing Page Content",
        "Product Description Writing",
        "Topic & Keyword Research",
      ],
      link: "/content-marketing-services",
    },
    {
      icon: contentIcon,
      title: "AI Automation Services",
      desc: "Automate your business operations with smart AI solutions including chatbots, lead management, customer support automation, and workflow optimization to save time, reduce costs, and improve efficiency and customer experience.",
      features: [
        "AI Chatbot Development",
        "WhatsApp Automation",
        "CRM Automation",
        "Email Automation Systems",
        "AI Content Generation Setup",
      ],
      link: "/ai-automation-services",
    },
  ];

  return (
    <section className="services">
      <div className="services-header">
        <div className="section-label">Our Core Services</div>
        <h2>
          Complete Web Development & Digital Growth Solutions for Modern
          Businesses
        </h2>
        <p className="service-para">
          Empower Web delivers high-performance web development, result-driven
          digital marketing, and intelligent AI automation solutions tailored
          for modern businesses. We build scalable websites, generate qualified
          leads, and streamline operations using data-driven strategies that
          improve visibility, increase conversions, and accelerate sustainable
          business growth in competitive digital markets.
        </p>
      </div>

      <div className="services-container">
        {servicesData.map((service, index) => (
          <div
            className="service-card"
            key={index}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className="card-accent"></div>
            <div className="icon-wrapper">
              <img
                src={service.icon}
                alt={service.title}
                className="service-icon"
              />
            </div>
            <h3>{service.title}</h3>
            <p>{service.desc}</p>
            <ul className="service-list">
              {service.features.map((item, i) => (
                <li key={i}>
                  <span className="arrow">→</span> {item}
                </li>
              ))}
            </ul>
            <a href={service.link} className="card-link">
              Learn More <span className="arrow-icon">→</span>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
